import styled from 'styled-components';

import { IWithSubmissionLabel } from 'hocs/withSubmissionLabel';

export const SettingsStyled = styled.div<IWithSubmissionLabel>`
  .form-content {
    height: ${({ isHiddenSubmissionLabel }) => `calc(100vh - ${isHiddenSubmissionLabel ? 222 : 282}px)`};
  }

  .ant-form-item {
    .ant-input-textarea {
      height: 124px;

      textarea.ant-input {
        padding-right: 35px;
      }
    }
  }
`;

export const AccountTabStyled = styled.div`
  .form-content {
    .ant-col {
      position: relative;

      .ant-picker {
        width: 100%;
      }

      .checkbox {
        position: absolute;
        top: 33px;
        left: 80px;
      }
    }
  }
`;

export const ShippingByCountryStyled = styled.div`
  > .ant-row {
    &:first-child {
      margin: 15px 0 10px 0;
      font-family: ${({ theme }) => theme.fontInterRegular};
    }
    // TODO ANTD
    &:not(:first-child) {
      border-bottom: 1px solid ${({ theme }) => theme.black10};
      margin-bottom: 5px;

      .ant-form-item {
        margin: 3px 0;

        .ant-input-borderless {
          color: ${({ theme }) => theme.black50};
        }
      }
    }

    .ant-form-item-control-input-content {
      .ant-checkbox-inner {
        background: ${({ theme }) => theme.colorBackgroundPrimary};
      }
    }
  }
`;

export const shippingTableClasses = 'rounded-lg px-2.5 pt-1 mt-2.5 border mb-0 duration-300';
